import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';  // Import i18n configuration
import App from './App';
// import reportWebVitals from './reportWebVitals';
import './assets/css/nunito.css';
import '../src/assets/css/tailwind.css';
import './assets/css/seasonalTheme.css';
import { applySeasonalThemeToDocument } from './component/themeUi';

const applyStoredTheme = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    const storedMode = localStorage.getItem('mode');
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    const mode = storedMode === 'dark' || storedMode === 'light'
        ? storedMode
        : (prefersDark ? 'dark' : 'light');

    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(mode);
};

applyStoredTheme();
applySeasonalThemeToDocument();

const container = document.getElementById('root');

const mountApp = () => {
    if (!container) return;

    const root = ReactDOM.createRoot(container);
    root.render(<App />);
};

mountApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
